/* src/app/private/components/client-package/client-addons/client-addons.component.scss */
/*# sourceMappingURL=client-addons.component.css.map */
